import React from "react";
import { Navigate } from "react-router-dom";


const SriBrowserPoolListComponent = React.lazy(
  () => import("../../../../../components/sri-browser-pool/components/list/page"),
);

export const sriBrowserPoolRoutes = [
  {
    path: "list",
    element: <SriBrowserPoolListComponent />,
  },
 
  {
    path: "",
    element: <Navigate replace to="/administration/sri-browser-pool/list" />,
  },
];
